import { render, staticRenderFns } from "./LowStockReport.vue?vue&type=template&id=40aa7cc0&"
import script from "./LowStockReport.vue?vue&type=script&lang=js&"
export * from "./LowStockReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports